import React, { useState, useRef, useCallback } from 'react';
import { array } from 'prop-types';
import useInterval from '@dragonfruit/hooks/useInterval';
import styles from './LiveCarousel.scss';
import {
  UP,
  DOWN,
  DEFAULT_OFFSET,
  PICTURE_HEIGHT,
  PICTURE_GUTTER,
} from './constants';
function LiveCarousel({ pictureGroups }) {
  const [offsetValue, setOffsetValue] = useState(DEFAULT_OFFSET);
  const groupRefs = useRef([]);

  const switchPicture = () => {
    groupRefs.current.forEach(ref => {
      const carouselDirection = ref.getAttribute('carousel-direction');
      if (carouselDirection === DOWN) {
        ref.prepend(ref.lastChild);
        return;
      }
      ref.append(ref.firstChild);
    });
  };

  useInterval(() => {
    setOffsetValue(prev => {
      if (prev >= PICTURE_HEIGHT + PICTURE_GUTTER) {
        switchPicture();
        return 0;
      }

      return prev + 1;
    });
  }, 40);

  const setPictureGroupRef = useCallback(
    ref => groupRefs.current.push(ref),
    []
  );

  const renderGroups = (pictures, index) => {
    const isEven = value => value % 2 === 0;
    const carouselDirection = isEven(index) ? DOWN : UP;
    const directionOperator = isEven(index) ? 1 : -1;
    return (
      <div
        className={styles.pictureGroups}
        ref={setPictureGroupRef}
        carousel-direction={carouselDirection}
        key={index}
        style={{
          transform: `translateY(${offsetValue * directionOperator}px)`,
        }}
      >
        {pictures.map((picUrl, index) => (
          <div
            key={index}
            className={styles.picture}
            style={{ backgroundImage: `url(${picUrl})` }}
          />
        ))}
      </div>
    );
  };

  return <div className={styles.root}>{pictureGroups.map(renderGroups)}</div>;
}
LiveCarousel.propTypes = {
  pictureGroups: array.isRequired,
};
export default LiveCarousel;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/LiveSection/components/LiveCarousel/LiveCarousel.jsx